import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, Radio, RadioGroup, FormControlLabel, FormControl } from '@mui/material';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

import Div from '@jumbo/shared/Div';
import ContentWrapper from 'app/components/ContentWrapper/ContentWrapper';
import ButtonStyled from 'app/components/ButtonStyled/ButtonStyled';

const CHANNELS = [
  { value: 'email', label: 'Email' },
  { value: 'sms', label: 'SMS' },
  { value: 'whatsapp', label: 'WhatsApp' },
];

const MfaChoice = () => {
  const navigate = useNavigate();
  const [channel, setChannel] = useState('email');

  useEffect(() => {
    if (!localStorage.getItem('mfa_pending')) {
      navigate('/micrositeLogin', { replace: true });
    }
  }, []);

  const onContinue = () => {
    localStorage.removeItem('mfa_ttl_exp');
    localStorage.setItem('mfa_channel', channel);
    navigate('/verifyMfa');
  };

  return (
    <Div className="custompage">
      <ContentWrapper>
        <Div className="content-padding">
          <Div className="back-icon">
            <KeyboardBackspaceIcon onClick={() => navigate(-1)} />
          </Div>
          <Div className="flex-justify-center-title">
            <Typography fontSize={24} fontWeight={600} color={'#C21B17'}>
              Pilih Metode Verifikasi
            </Typography>
          </Div>

          <Div sx={{ mt: 3, display: 'flex', justifyContent: 'center' }}>
            <Typography fontSize={14} fontWeight={400} textAlign="center" sx={{ maxWidth: 360 }}>
              Pilih bagaimana Anda ingin menerima kode OTP untuk verifikasi login.
            </Typography>
          </Div>

          <Div sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
            <FormControl>
              <RadioGroup value={channel} onChange={(e) => setChannel(e.target.value)}>
                {CHANNELS.map((c) => (
                  <FormControlLabel
                    key={c.value}
                    value={c.value}
                    control={<Radio sx={{ color: '#C21B17', '&.Mui-checked': { color: '#C21B17' } }} />}
                    label={c.label}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </Div>

          <Div className="flex-justify-center" sx={{ mt: 4 }}>
            <ButtonStyled
              onClick={onContinue}
              btnText={'Lanjutkan'}
              preset={'primary'}
              sx={{ maxWidth: '451px' }}
            />
          </Div>
        </Div>
      </ContentWrapper>
    </Div>
  );
};

export default MfaChoice;
